export default {
  // START GENERATED IMPORTS
  'mapBox': { loader: () => import('../../../blocks/MapBox/script.js'), strategy: 'visible' },
  'mapBoxDynamic': { loader: () => import('../../../blocks/MapBoxDynamic/script.js'), strategy: 'visible' },
  'searchDirectory': { loader: () => import('../../../blocks/SearchDirectory/script.js'), strategy: 'visible' },
  'searchText': { loader: () => import('../../../blocks/SearchText/script.js'), strategy: 'visible' },
  'seasonalSentence': { loader: () => import('../../../blocks/SeasonalSentence/script.js'), strategy: 'visible' },
  // END GENERATED IMPORTS
}
